<template>

  <v-container fluid class="page page-login">

    <v-row v-if="isLoggingIn">
      <v-col class="d-flex align-center justify-center">
        <v-progress-circular indeterminate :size="50" style="margin-top:30px" color="primary" />
      </v-col>
    </v-row>

    <!-- Local Account Login -->
    <v-container v-else>
      <!-- (login form) -->
      <v-row>
        <v-col class="d-flex flex-column align-center justify-center">
          <local-auth-login @login="performLogin" />
          <!-- Forgot password link -->
          <v-btn
              v-if="enableForgotPassword"
              small
              plain
              color="primary"
              class="mt-1"
              @click="$root.goTo('forgot-password')">
            Forgot Password?
          </v-btn>
        </v-col>
      </v-row>

      <!-- (login error display) -->
      <template v-if="loginError">
        <transition name="fade" appear>
          <v-row>
            <v-col class="d-flex align-center justify-center">
              <div class="error-container pl-8 pr-3 py-3">
                <v-icon class="mr-2" color="#cc0000">mdi-alert-circle-outline</v-icon>
                <span class="login-error-message-text">{{ loginError }}</span>
                <v-btn icon small color="#727272" class="ml-5" @click="clearLoginError">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </transition>
      </template>
    </v-container>

    <!-- Google Login --->
    <v-row v-if="enableGoogle && !isLoggingIn">
      <v-col class="d-flex flex-column align-center justify-center">
        <div style="text-align:center;">- or -</div>
        <google-auth-login />
      </v-col>
    </v-row>

    <!-- Track order link -->
    <v-row class="mt-1" v-if="!isLoggingIn">
      <v-col class="d-flex align-center justify-center">
        <v-btn text color="yellow darken-3" @click="$root.goTo('track-order')">
          <v-icon left>mdi-package-variant-closed</v-icon>
          <span>Track an Order</span>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Sign-up link -->
    <v-row class="mt-2" v-if="enableRegistration && !isLoggingIn">
      <v-col class="d-flex align-center justify-center">
        <div class="d-flex flex-column align-center justify-center sign-up-container py-4">
          <div style="color:#727272;">Don't have an account?</div>
          <v-btn
              plain
              class="mt-2"
              @click="$root.goTo('register-account-type-select')">
            Sign-up with {{ appName }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- App version -->
    <div align="center" class="mt-8" style="font-size:15px;color:#525252;font-style:italic;" v-if="showAppVersion && !isLoggingIn">
      v{{ appVersion }}
    </div>

  </v-container>

</template>

<script>
import LocalAuthLogin from '@/components/auth/LocalAuthLogin'
import GoogleAuthLogin from '@/components/auth/GoogleAuthLogin'

export default {
  name: 'LoginPage',

  components: {
    LocalAuthLogin,
    GoogleAuthLogin
  },

  data () {
    return {
      enableForgotPassword: true,
      enableRegistration: true,
      enableGoogle: false,
      showAppVersion: true,
      isLoggingIn: false,
      loginError: null
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    appVersion () {
      return this.$store.getters['app/version']
    }
  },

  methods: {
    clearLoginError () {
      this.loginError = null
    },

    async performLogin (creds) {
      this.loginError = null
      this.isLoggingIn = true

      try {
        await this.$root.login(creds)
        this.$root.goTo('home') // direct user to home page
      } catch (err) {
        this.isLoggingIn = false

        // Handle error for user display
        let message = 'Error logging-in.'
        if (err.code) {
          switch (err.code) {
            case 'NotAuthorizedException': message = 'Invalid email/password'; break
            case 'UserNotConfirmedException': message = 'You must confirm your email to login'; break
            default: message = 'Cannot login at this time.'
          }
        } else {
          message = err.message || err.text
        }
        this.loginError = message
      }
    }
  }
}
</script>

<style scoped>
  .page-login {
    margin-top: 47px;
  }

  .theme--dark.v-card {
    background: #080404;
  }

  .local-auth-login {
    width: 400px;
    background: #080404;
    text-align: center;
  }

  .google-auth-login {
    width: 400px;
    max-width: 400px;
    text-align: center;
  }

  .error-container {
    border: 1px solid #cc0000;
    border-radius: 4px;
    max-width: 400px;
  }

  .login-error-message-text {
    font-size: 15px;
    color: #cc0000;
    font-weight: 400;
  }

  .sign-up-container {
    width: 280px;
    border: 1px solid #252525;
    border-radius: 8px;
  }
</style>
